import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { Component, ViewContainerRef } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { BiUrls } from '../../biUrls';

@Component({
    selector: 'scope',
    templateUrl: 'scope.component.html'
})

export class ScopeComponent {

    public scopeReg: string = '';
    public sPage: number = 0;
    public lastRegex: string = '';

    public scopeData: any = { id: null, name: '', scopeDesc: '', deleted: 0 };
    public mainPage: boolean = true;
    public scopePage: boolean = false;
    public scopeList: any = [];
    public saveButton: boolean = false;
    public accessDenied: boolean = false;
    public onStart: boolean = false;
    public isEdit: boolean = false;
    public oldName: string = 'oldName';
    public pageNo: number = 0;
    public pageSize: number = 10;
    public startingPage: number = 0;
    public currentPage: number = 1;
    public selectedScopeId: number;
    public endingPage: number;
    public totalScope: number = 0;
    public totalPages: number = 0;
    public loader: boolean = false;

    constructor(
        public scopeService: MDMService,
        public toastr: ToasterComponent,
        public vcr: ViewContainerRef) {
        this.toastr.setViewRef(vcr);
    }

    ngOnInit() {
        if (this.scopeService.isBIAdmin) {
            this.loadScope();
        } else {
            this.accessDenied = true;
        }
    }

    public entityOps(event) {
        if (this.selectedScopeId == null) {
            this.selectedScopeId = event.target.id;
        } else {
            this.selectedScopeId = null;
        }
    }

    public closeDropDown(event) {
        this.selectedScopeId = null;
    }

    public onPageChange(event: number): void {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        this.setEndingPage();

        if (this.scopeReg != '') {
            this.searchPScope();
        } else {
            this.loadScope();
        }
    }

    public setEndingPage() {
        let self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (this.totalScope > this.pageSize) {
                this.endingPage = this.pageSize;
            } else {
                this.endingPage = this.totalScope;
            }
        } else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > this.totalScope) {
                this.endingPage = this.totalScope;
            }
        }
    }

    // For Pagination
    public OnPageSizeChanged(event) {
        this.pageSize = event.target.value;
        let maxPage = Math.floor(this.totalScope / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadScope();
    }

    public loadScope() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            self.mainPage = true;
            this.scopeService.getDataByPage(BiUrls.SCOPE, self.pageNo, self.pageSize).then((res) => {
                self.scopeList = [];
                self.totalPages = 0;
                self.totalScope = 0;
                if (res != undefined) {
                    self.scopeList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements :
                        self.toastr.showError('No results found');
                    self.totalScope = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                    self.setEndingPage();
                    resolve('completed');
                }
                self.loader = false;
            }, (error) => {
                console.error(error);
            });
        });
    }

    public addNewScope() {
        this.mainPage = false;
        this.scopePage = true;
        this.scopeData = { id: null, name: '', scopeDesc: '', deleted: 0 };
    }

    // By Lalu
    public searchPScope() {
        let self = this;
        self.loader = true;
        self.mainPage = true;
        self.scopeList = [];
        if (self.scopeReg != self.lastRegex) {
            self.sPage = 0;
        } else {
            self.sPage = self.currentPage - 1;
            self.currentPage = 1;
        }
        self.lastRegex = self.scopeReg;
        self.scopeService.search(BiUrls.SCOPE, BiUrls.SEARCH_P_SCOPE,
            self.scopeReg, self.sPage, self.pageSize).then((res) => {
                self.loadSearchedPScope(res);
                self.loader = false;
            }, (error) => {
                console.error(error);
            });
    }

    // By Lalu
    public loadSearchedPScope(res) {
        let self = this;
        self.scopeList = (res != undefined) ? res.data.pageElements : [];
        self.totalScope = (res != undefined) ? res.data.total : 0;
        self.setEndingPage();
    }

    public onSave() {
        let self = this;
        self.scopeData.name = self.scopeData.name.trim();
        let validate: any = self.validater();
        if (validate != '') {
            self.toastr.showError(validate);
        } else {
            self.loader = true;
            self.saveButton = true;
            if (self.isEdit) {
                console.log('ON EDIT');
                self.scopeService.update(BiUrls.SCOPE, self.scopeData).then((res) => {
                    self.loadAfterSaveOrEdit(res, 'edit');
                });
            } else {
                console.log('ON SAVE');
                self.scopeService.save(BiUrls.SCOPE, self.scopeData).then((res) => {
                    self.loadAfterSaveOrEdit(res, 'new');
                });
            }
            self.oldName = 'oldName';
        }
    }

    public loadAfterSaveOrEdit(result, type) {
        let self = this;
        self.totalPages = Math.floor(self.totalScope / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo :
            self.totalPages;
        self.currentPage = self.pageNo + 1;
        let text = type == 'new' ? 'Scope saved successfully' : 'Changes saved successfully';
        if (result.error == undefined && result.success == true) {
            self.toastr.showSuccess(text);
            self.loadScope().then((res) => {
                self.saveButton = false;
                self.mainPage = true;
                self.scopePage = false;
                self.isEdit = false;
                self.loader = false;
            }, (error) => {
                console.error(error);
            });
        } else {
            self.toastr.showError(result.errorMessage ? result.errorMessage : 'Failed to save Scope');
            self.saveButton = false;
            self.loader = false;
        }


    }

    public clickEdit(scope) {
        console.log('On Edit Controller ...');
        let self = this;
        self.loader = true;
        self.selectedScopeId = null;
        self.scopeService.getDataById(BiUrls.SCOPE, scope.id).then((res) => {
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load the Scope');
                self.loadScope();
            } else {
                scope = res.data;
                self.isEdit = true;
                self.loader = false;
                self.mainPage = false;
                self.scopePage = true;
                self.scopeData = JSON.parse(JSON.stringify(scope));
                self.oldName = self.scopeData.name;
            }
            self.loader = false;
        }, (error) => {
            console.error(error);
        });
    }

    public onBack() {
        this.mainPage = true;
        this.scopePage = false;
        this.selectedScopeId = null;
        this.scopeData = {};
        this.oldName = 'oldName';
        this.isEdit = false;
    }

    public delete(scope) {
        let self = this;
        self.scopeService.delete(BiUrls.SCOPE, scope.id).then((response) => {
            self.loader = false;
            self.pageNo = self.scopeList.length == 1 ?
                self.totalScope == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadScope();
            if (response == undefined || response.data == undefined) {
                self.toastr.showError('Unable to remove Scope');
            } else {
                self.toastr.showSuccess(scope.name + ' removed successfully');
            }
        }, (error) => {
            console.error(error);
        });
    }

    public removeScope(scope) {
        let r = confirm('Are you sure you want to remove the Scope ' + scope.name + ' ?');
        if (r == true) {
            this.delete(scope);
        }
    }

    public validater() {
        if (this.scopeData.name == undefined || this.scopeData.name == '') {
            return 'Please enter the name for Scope';
        } else if (this.oldName != this.scopeData.name) {
            this.scopeData.name = this.scopeData.name.trim();
            this.scopeData.scopeDesc = this.scopeData.scopeDesc != undefined ?
                this.scopeData.scopeDesc.trim() : null;
            return '';
        } else {
            this.scopeData.name = this.scopeData.name.trim();
            this.scopeData.scopeDesc = this.scopeData.scopeDesc != undefined ?
                this.scopeData.scopeDesc.trim() : null;
            return '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/scope.component.ts